import { Box, Text, Heading } from '@primer/react';
import Reveal from './Reveal';

const results = [
  {
    company: 'GitHub',
    stat: '37% faster, 91% fewer dead clicks',
    quote:
      'Pegasus UX rebuilt the GitHub Support Portal from the ground up, cutting page load time 37% and dead clicks 91%, while shipping production-ready AI feature prototypes alongside the GitHub engineering team.',
  },
  {
    company: 'Clapper',
    stat: '$3M raised',
    quote:
      'Pegasus UX led a UX research engagement for Clapper. Shortly after, the company closed a $3M investment round that helped launch them ahead of plan.',
  },
  {
    company: 'King Architectural Metals',
    stat: '+19% sales, -12% support calls',
    quote:
      "Pegasus UX redesigned King Architectural Metals' e-commerce experience, increasing sales 19% and cutting inbound support calls 12% after launch.",
  },
];

function CaseResults() {
  return (
    <Box sx={{ backgroundColor: 'canvas.default', paddingX: ['24px', '48px', '100px'], paddingY: [7, 8, 9] }}>
      <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
        <Reveal>
          <Text
            as="p"
            sx={{
              margin: 0,
              marginBottom: 2,
              fontSize: 1,
              fontWeight: 600,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: 'fg.muted',
            }}
          >
            Case Results
          </Text>
          <Heading
            as="h2"
            sx={{
              margin: 0,
              marginBottom: [6, 7, 8],
              maxWidth: '700px',
              fontFamily: "'Fraunces', serif",
              fontWeight: 300,
              fontSize: ['2rem', '2.75rem', '3.25rem'],
              lineHeight: 1.25,
              color: 'fg.default',
            }}
          >
            Real outcomes for real companies.
          </Heading>
        </Reveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
            gap: [5, 5, 5],
          }}
        >
          {results.map((result, index) => (
            <Reveal key={result.company} delay={index * 0.06}>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: '16px',
                  border: '1px solid',
                  borderColor: 'border.default',
                  padding: 4,
                }}
              >
                <Text
                  as="p"
                  sx={{
                    margin: 0,
                    marginBottom: 3,
                    fontFamily: "'Fraunces', serif",
                    fontStyle: 'italic',
                    fontSize: 3,
                    lineHeight: 1.3,
                    backgroundImage: 'linear-gradient(90deg, #60a5fa, #a78bfa)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {result.stat}
                </Text>

                <Text as="p" sx={{ margin: 0, marginBottom: 4, fontSize: 1, lineHeight: 1.7, color: 'fg.muted' }}>
                  &ldquo;{result.quote}&rdquo;
                </Text>

                <Text
                  as="p"
                  sx={{
                    margin: 0,
                    marginTop: 'auto',
                    fontSize: 0,
                    fontWeight: 600,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    color: 'fg.default',
                  }}
                >
                  {result.company}
                </Text>
              </Box>
            </Reveal>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default CaseResults;
